import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { PlainModal } from '@client/new/components/Modal/Modal';
import { colors } from '@client/new/components/colors';
import directMessagesImage from '/static/images/direct-messages.png';

type DirectMessagesModalProps = {
  open: boolean;
  toggle: () => void;
  onSubmit: () => Promise<void>;
  isEnabled: boolean;
  isSubmitting: boolean;
};

const getModalConfig = (isEnabled: boolean) => {
  if (isEnabled) {
    return {
      title: 'Are you sure?',
      description:
        'Your subscribers will no longer be able to  send you direct messages and reply to stories.',
      submitLabel: 'Turn off',
      actionButtonSx: { backgroundColor: colors.error100 },
    };
  }
  return {
    title: 'Ready for Direct Messaging?',
    description:
      'Your subscribers wlll be able to  send you direct messages and reply to stories.',
    submitLabel: 'Turn on',
  };
};

export const DirectMessagesModal = ({
  isEnabled,
  open,
  toggle,
  onSubmit,
  isSubmitting,
}: DirectMessagesModalProps) => {
  const { title, description, submitLabel, actionButtonSx } =
    getModalConfig(isEnabled);

  return (
    <PlainModal
      isOpen={open}
      onClose={toggle}
      height={'auto'}
      sx={{
        padding: '32px',
        maxWidth: '415px',
        maxHeight: 'fit-content',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          gap: 16,
        }}
        className="flex flex-col gap-6 justify-center items-center"
      >
        <img src={directMessagesImage} className="max-w-[265px]" />
        <div className="flex flex-col justify-center items-center gap-4">
          <Typography sx={{ fontSize: 24, fontWeight: 700 }}>
            {title}
          </Typography>
          <Typography
            sx={{ fontSize: 16, fontWeight: 500, textAlign: 'center' }}
          >
            {description}
          </Typography>
        </div>
        <div className="w-full flex flex-col justify-center gap-2">
          <Button
            variant="contained"
            onClick={onSubmit}
            sx={{
              width: '100%',
              ...(actionButtonSx || {}),
            }}
          >
            {isSubmitting ? (
              <CircularProgress className="h-[20px] w-[20px]" />
            ) : (
              submitLabel
            )}
          </Button>
          <Button variant="text" onClick={toggle} className="font-medium">
            Cancel
          </Button>
        </div>
      </Box>
    </PlainModal>
  );
};
